import { FilterItem } from "@sscs/types";
import { ExportJob } from "Types";

export type AuditFilters = Partial<{
  action: FilterItem;
  outcome: FilterItem;
  user_email: FilterItem;
  auth_context: FilterItem;
  resource_type: FilterItem;
  group_id: FilterItem;
  resource_name: FilterItem;
  project_name: FilterItem;
  package_name: FilterItem;
}>;

export type AuditRequestFilterItem = FilterItem & {
  filter_by: keyof AuditFilters;
};

export type AuditLogSearchRequestBody = {
  datetime_start: string;
  datetime_end: string;
  filters: AuditFilters;
};

type AuditLogOutcome = "SUCCESS" | "FAILURE";

type AuditAuthContext = "SESSION" | "TOKEN";

type FailureOutcomeDetails = {
  code: string;
  message: string;
};

export const AUDIT_RESOURCE_TYPES = {
  group: "Group",
  organization: "Organization",
  project: "Project",
  package: "Package",
  version: "Version",
  filestream_file: "File stream file",
  user: "User",
} as const;

export type ResourceType = keyof typeof AUDIT_RESOURCE_TYPES;

export type AuditLog = {
  log_id: string;
  action: string;
  resource_type: ResourceType;
  schema_version: string;
  resource_name: string | null;
  resource_id: string | null;
  group_id: string | null;
  project_id: string | null;
  project_name: string | null;
  package_id: string | null;
  package_name: string | null;
  outcome: AuditLogOutcome;
  changes: Record<string, Record<string, string>> | null;
  context: Record<string, string> | null;
  error: FailureOutcomeDetails | null;
  user_id: string | null;
  user_email: string | null;
  user_first_name: string | null;
  user_last_name: string | null;
  ip_address: string | null;
  user_agent_raw: string | null;
  user_agent_category: "browser" | "api_client" | "script" | null;
  request_path: string | null;
  request_id: string | null;
  auth_context: AuditAuthContext | null;
  timestamp: string;
};

export type SearchAuditLogsResponse = {
  entries: AuditLog[];
};

export type SearchAuditLogsRequest = {
  body: AuditLogSearchRequestBody;
};

export type ExportJobsResponse = {
  match_count: number;
  jobs: ExportJob[];
};

export type ExportJobsRequest = {
  limit: number;
  offset: number;
};

export type ExportFormData = {
  name: string;
  should_create_cef: boolean;
  should_create_ndjson: boolean;
};

export type ExportAuditLogsRequestBody = AuditLogSearchRequestBody &
  ExportFormData;

export type ExportAuditLogsRequest = {
  body: ExportAuditLogsRequestBody;
};

export type TimeRangeFormData = {
  startDate: string;
  endDate: string;
};

export type AuditEnums = {
  actions: string[];
};
